"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What does Evermark produce for substations and power plants?",
  answer: "Evermark Industrial Solutions produces equipment and apparatus nameplates, panel nameplates and schedules, arc flash labels, cable and conductor ID tags, valve and asset tags, and high-voltage warning signs for substations, switchgear, and generation plants."
}, {
  question: "What material holds up outdoors in a substation?",
  answer: "Evermark Industrial Solutions specifies engraved stainless steel and anodized aluminum for outdoor substation and switchgear identification, because the engraved mark and the metal resist UV, weather, and temperature for the long service life utility equipment requires."
}, {
  question: "Can Evermark match our utility's nameplate standard?",
  answer: "yes — Evermark Industrial Solutions produces nameplates to a utility's existing format, materials, and numbering, and stores the approved format for consistent reorders across the system."
}, {
  question: "Does Evermark produce high-voltage warning and danger signs?",
  answer: "yes — Evermark Industrial Solutions produces high-voltage warning and danger signs to your specified content and the applicable ANSI Z535 safety-sign format; the required wording, placement, and adequacy are determined by the utility or a qualified person, not by Evermark."
}, {
  question: "Can you produce arc flash labels for our switchgear?",
  answer: "yes — Evermark Industrial Solutions produces arc flash labels from the data in your arc flash study; Evermark makes the label and does not perform the study or determine the hazard values."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="faq" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight">
            Utility & Power Generation Identification — Common Questions
          </h2>
        </div>

        <div className="bg-card rounded-xl p-6 md:p-8 shadow-sm border border-border">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-left font-default text-lg md:text-xl font-semibold text-card-foreground hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}